export const HOMEPAGE_CONTACT_URL = "https://redjourney.jp/contact/";
